import MaintenancePlan from 'pages/CatalogPage/IAM/MaintenancePlan/MaintenancePlan';

export default MaintenancePlan;
